import React from "react";
import MRMLogo from "@/assets/images/LogoMRM-HD.png";
import styled from "styled-components";
import PhoneIcon from "@mui/icons-material/Phone";

import { Box, Grid, Typography } from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import FmdGoodIcon from "@mui/icons-material/FmdGood";

export const StyledNameImg = styled.img`
  padding: 0 2rem;
  width: 14rem;
  height: 2rem;
`;

export const StyledLogoDiv = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledLogoImg = styled.img`
  transform: scale(0.5);
  @media (max-width: 900px) {
    transform: scale(0.4);
  }
`;

export const Footer: React.FC = () => {
  return (
    <footer>
      <Box
        sx={{
          backgroundColor: "#1F6B45",
          display: "flex",
          width: "100%",
          padding: "4rem 2rem",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Grid
          container
          rowSpacing={2}
          spacing={1}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Grid item xs={12} md={3} lg={3}>
            <Box
              sx={{
                width: "100%",
                color: "white",
                height: "4rem",
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "center", lg: "auto" },
                pb: { xs: "2rem", lg: "auto" },
              }}
            >
              <StyledLogoImg src={MRMLogo} />
            </Box>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <Box
              sx={{
                color: "white",
                height: "4rem",
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "left", lg: "auto" },
              }}
            >
              <FmdGoodIcon />
              <Typography
                sx={{
                  maxWidth: { xs: "auto", lg: "12rem" },
                  paddingLeft: "1rem",
                }}
                fontFamily={"Montserrat"}
              >
                Dir. Misiones 1537 Piso 5 Montevideo - Uruguay
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <Box
              sx={{
                color: "white",
                height: "4rem",
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "start", lg: "auto" },
              }}
            >
              <PhoneIcon />
              <Typography
                sx={{ paddingLeft: "1rem" }}
                fontFamily={"Montserrat"}
              >
                Tel. (+598) 2 916 3171
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <Box
              sx={{
                color: "white",
                height: "4rem",
                display: "flex",
                alignItems: "center",
              }}
            >
              <MailOutlineIcon />
              <Typography
                sx={{ paddingLeft: "1rem" }}
                fontFamily={"Montserrat"}
              >
                mrm@mrm.com.uy
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </footer>
  );
};

export default Footer;
